import { useMemo } from 'react';

import { PasswordValidation } from 'helpers';
import { usePageTitleTranslation } from 'libs/navigation';

import { useChangePassword } from '../hooks/useChangePassword';
import { PasswordSettingsView } from '../views/PasswordSettingsView';

export const PasswordSettingsContainer = () => {
  const {
    isOpenVerificationDialog,
    formError,
    submitLoading,
    onSubmit,
    onCloseVerificationDialog,
  } = useChangePassword();

  const passwordValidation = useMemo(
    () => PasswordValidation.parseByValidationRule(),
    []
  );

  usePageTitleTranslation('settings.title');

  return (
    <PasswordSettingsView
      initialErrors={formError}
      isOpenVerificationDialog={isOpenVerificationDialog}
      passwordValidation={passwordValidation}
      submitLoading={submitLoading}
      onCloseVerificationDialog={onCloseVerificationDialog}
      onSubmit={onSubmit}
    />
  );
};
